<app-progress-spinner [enabled]="loading()" />
@if (!loading()) {
  @for (au of history(); track au) {
    <div>
      <ul>
        <li>
          @if (au.updatedAt) {
            <div
              [innerHTML]="
                'COMMON.LABEL.AUDIT_INFO_MSG'
                  | translate
                    : {
                        user: au.updater,
                        date: au.updatedAt | date: 'MM/dd/yyyy hh:mm:ss a',
                      }
              "
            ></div>
          } @else {
            <div
              [innerHTML]="
                'COMMON.LABEL.INVALID_DATE_AUDIT_INFO_MSG'
                  | translate
                    : {
                        user: au.updater,
                      }
              "
            ></div>
          }
        </li>
      </ul>
    </div>
  } @empty {
    <div [innerHTML]="'COMMON.LABEL.NO_AUDIT_INFO_MSG' | translate"></div>
  }
}
